export default "__VITE_ASSET__dcf81846__"